<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  pending: { type: Boolean, default: false },
  acceptedEmoji: { type: String, default: '' },
});
const emit = defineEmits(['select']);
const { t } = useI18n();
const emojis = ['✅', '👍', '❤️', '👀'];
</script>

<template>
  <div
    class="flex items-center gap-0.5 text-sm"
    :aria-label="t('CONVERSATION.WHATSAPP_REACTION.PICKER')"
    :aria-busy="pending"
  >
    <button
      v-for="emoji in emojis"
      :key="emoji"
      type="button"
      class="rounded-md px-1.5 py-0.5 hover:bg-n-alpha-2 focus-visible:ring-2 focus-visible:ring-n-brand disabled:opacity-40 disabled:cursor-wait"
      :class="{ 'bg-n-teal-2': emoji === '✅' }"
      :disabled="pending || (!!acceptedEmoji && acceptedEmoji !== emoji)"
      :title="
        acceptedEmoji && acceptedEmoji !== emoji
          ? t('CONVERSATION.WHATSAPP_REACTION.REPLACEMENT_UNAVAILABLE')
          : t('CONVERSATION.WHATSAPP_REACTION.SEND', { emoji })
      "
      :aria-label="t('CONVERSATION.WHATSAPP_REACTION.SEND', { emoji })"
      @click.stop="emit('select', emoji)"
    >
      {{ emoji }}
    </button>
    <span v-if="pending" role="status" class="text-xs text-n-slate-10">
      {{ t('CONVERSATION.WHATSAPP_REACTION.PENDING') }}
    </span>
  </div>
</template>
